export const SENSITIVE_WORDS_BASE64 = Object.freeze([
  '5Lmg6L+R5bmz',
  '5aSp5a6J6Zeo5bm/5Zy6',
  '5aSp5a6J6Zeo5LqL5Lu2'
]);

function decodeBase64Utf8(encodedText) {
  const binaryText = atob(encodedText);
  const bytes = Uint8Array.from(binaryText, char => char.charCodeAt(0));
  return new TextDecoder('utf-8').decode(bytes);
}

export const SENSITIVE_WORDS = Object.freeze(
  SENSITIVE_WORDS_BASE64.map(decodeBase64Utf8)
);

export const SENSITIVE_CONTENT_BLOCK_MESSAGE = '因法律法规，不能为继续为您回答';

export function createSensitiveContentFilter(words = SENSITIVE_WORDS) {
  const normalizedWords = words.filter(word => typeof word === 'string' && word.length > 0);
  const retainedLength = Math.max(0, ...normalizedWords.map(word => word.length - 1));
  let pendingText = '';
  let blocked = false;

  return {
    push(text) {
      if (blocked || typeof text !== 'string' || text.length === 0) {
        return { blocked, safeText: '' };
      }

      pendingText += text;
      if (normalizedWords.some(word => pendingText.includes(word))) {
        blocked = true;
        pendingText = '';
        return { blocked: true, safeText: '' };
      }

      const safeLength = Math.max(0, pendingText.length - retainedLength);
      const safeText = pendingText.slice(0, safeLength);
      pendingText = pendingText.slice(safeLength);
      return { blocked: false, safeText };
    },

    flush() {
      if (blocked) return '';
      const safeText = pendingText;
      pendingText = '';
      return safeText;
    },

    discard() {
      pendingText = '';
    }
  };
}

export function applySensitiveContentBlock(message) {
  if (!message) return;

  message.content = SENSITIVE_CONTENT_BLOCK_MESSAGE;
  message.thinking = '';
  message.isThinking = false;
  message.isGeneratingImage = false;
  message.kbRelevanceJudging = false;
  message.chatStatus = 'idle';
  message.statusText = '';
}
